module.exports = __webpack_public_path__ + "img/IMG_9022_L_Black_MockedUp.df8decd3.jpg";